import { Wrapper, FirstCrossPart, SecondCrossPart } from './CrossIcon.styles';

const CrossIcon = ({ opened }) => (
  <Wrapper>
    <FirstCrossPart opened={opened} />
    <SecondCrossPart opened={opened} />
  </Wrapper>
);

export default CrossIcon;
